import {Component, OnInit} from '@angular/core';
import {ResourceModel} from 'src/app/modules/resources/models/resources.model';
import {ResourcesService} from 'src/app/modules/resources/service/resources.service';
import {Platform} from '@ionic/angular';
import {NavService} from 'src/app/services/nav.service';

@Component({
  selector: 'app-search-widget',
  templateUrl: './search-widget.component.html',
  styleUrls: ['./search-widget.component.scss'],
})
export class SearchWidgetComponent implements OnInit {
  public query: string = '';
  public showResults = false;
  public results: ResourceModel[] = [];

  public isFocused = false;

  private searchTimeout: NodeJS.Timeout;

  public resourceList: ResourceModel[] = null;
  public resourceListValid = false;

  constructor(
        private resourceService: ResourcesService,
        private platform: Platform,
        private linkSystem: NavService,
  ) { }

  ngOnInit() {
    this.getResources();
  }

  private getResources(): void {
    if (this.resourceList === null || !this.resourceListValid) {
      this.resourceService.getResourceList().then(data => {
        this.resourceList = data;
        this.resourceListValid = true;
      });
    }
  }

  public handleSearchDebounced() {
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.handleSearch();
    }, 300);
  }

  public handleSearch() {
    const value = this.query.toLowerCase();

    if (value.trim() === '') {
      this.results = [];
      this.showResults = false;
      return;
    }

    this.results = this.resourceList.filter(item =>
      item.title.toLowerCase().indexOf(value) !== -1 ||
      item.description.toLowerCase().indexOf(value) !== -1 ||
      item.folder.toLowerCase().indexOf(value) !== -1);

    this.showResults = this.results.length > 0;
  }

  public searchItemClick(item: ResourceModel) {
        this.platform.ready().then(() => {
            this.linkSystem.toLink(item.link_universal);
        });
  }

  public onFocus() {
    this.isFocused = true;
  }

  public onBlur() {
    setTimeout(() => {
      this.isFocused = false;
    }, 200);
  }
}
